const WORKSPACE_CONTEXT_KEYS = ["agentId", "channelId", "sessionId"] as const;

/**
 * Keep the selected agent and chat when navigating to a page outside the
 * workspace route, such as a workflow canvas or run-history page.
 */
export function withWorkspaceContext(
  path: string,
  source: URLSearchParams,
): string {
  const params = new URLSearchParams();
  for (const key of WORKSPACE_CONTEXT_KEYS) {
    const value = source.get(key);
    if (value) params.set(key, value);
  }

  const query = params.toString();
  if (!query) return path;
  return `${path}${path.includes("?") ? "&" : "?"}${query}`;
}
